<div class="bg-bluesky result-exam pt-5 text-primary">
  <div class="container-fluid mx-auto">
    <div class="bg-white rounded p-2 p-md-5 mx-5">
      <div class="text-right bg-white pr-4 rounded-top">
        <i class="fa-solid fa-xmark text-primary pointer icon-lg cross-icon" (click)="navigateToLevels()"></i>
      </div>

      <div class="text-center">
        <h3 *ngIf="level">Resultats {{level.name}}</h3>
        <div class="d-flex justify-content-center align-items-center bolder" *ngIf="examResult">
          <i class="fa-solid fa-stopwatch mr-2"></i>
          {{ getTimer() }}
        </div>
      </div>

      <div class="row mt-3 resume-exam" *ngIf="examResult">
        <div class="col-12 col-md-6 text-center border-md-right">
          <div class="py-5 w-75 mx-auto bolder d-flex flex-column">
            <app-progress-circle [responsive]="false" [radius]="80" [title]="displayScore(examResult.scoreGlobal, '990')" [percent]="calculPercent(examResult.scoreGlobal, 990)"></app-progress-circle>
            <div class="mt-3 d-flex justify-content-center align-items-center">
              <div class="rounded bg-success text-white px-2 py-1 mx-2 d-flex justify-content-center align-items-center">
                <i class="fa-solid fa-square-check mr-1 icon-xs"></i>
                {{examResult.detailScores.success}}
              </div>
              <div class="rounded bg-muted text-white px-2 py-1 mx-2 d-flex justify-content-center align-items-center">
                <i class="fa-solid fa-square-minus mr-1 icon-xs"></i>
                {{examResult.detailScores.void}}
              </div>
              <div class="rounded bg-danger text-white px-2 py-1 mx-2 d-flex justify-content-center align-items-center">
                <i class="fa-solid fa-ban mr-1 icon-xs"></i>
                {{examResult.detailScores.failure}}
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="p-0 p-md-2 w-75 mx-auto bolder d-flex flex-column justify-content-center my-auto h-100">
            <div class="border-bottom py-4">
              <div class="media mb-2">
                <div class="media-body align-self-center">
                  <app-progress-bar-simple height="30" [score]="calculPercent(examResult.scoreListening, 495)"></app-progress-bar-simple>
                </div>
                <div class="ml-3 align-self-center nunito text-progress-bar">
                  {{examResult.scoreListening}} / 495
                </div>
              </div>
              <h4 class="text-center">Listening</h4>
            </div>
            <div class="py-4">
              <div class="media mb-2">
                <div class="media-body align-self-center">
                  <app-progress-bar-simple height="30" [score]="calculPercent(examResult.scoreReading, 495)"></app-progress-bar-simple>
                </div>
                <div class="ml-3 align-self-center nunito text-progress-bar">
                  {{examResult.scoreReading}} / 495
                </div>
              </div>
              <h4 class="text-center">Reading</h4>
            </div>
          </div>
        </div>
        <div class="col-12 mt-5 text-center">
          <button class="btn btn-primary bolder px-3 py-2" (click)="navigateToLevels()" translate>Retour</button>
        </div>
      </div>

    </div>

    <div class="bg-white rounded p-5 mx-5 mt-5" *ngIf="examResult">
      <h3 class="mb-4" translate>En résumé</h3>
      <div class="row">
        <div class="col-12 col-lg-6 mb-3 mb-lg-0">
          <div class="shadow rounded p-3 p-md-4 h-100">
            <h5>Listening</h5>
            <div class="d-flex flex-column flex-lg-row justify-content-between">
              <div class="text-center">
                <div class="mx-auto" style="max-height: 100px">
                  <app-progress-circle [responsive]="false" [radius]="50" [title]="displayPercent(calculPercent(examResult.scoreListening, 495))" [percent]="calculPercent(examResult.scoreListening, 495)"></app-progress-circle>
                </div>
              </div>
              <div class="d-flex flex-column w-100 mt-4 mt-lg-0">
                <div class="d-flex flex-column mb-3">
                  <div class="d-flex justify-content-between">
                    <h5>Listening 1</h5>
                    <p>{{examResult.scores.listening.first.score}}/{{examResult.scores.listening.first.max}}</p>
                  </div>
                  <app-progress-bar-simple [score]="calculPercent(examResult.scores.listening.first.score, examResult.scores.listening.first.max)"></app-progress-bar-simple>
                </div>
                <hr class="text-muted w-100 my-3">
                <div class="d-flex flex-column mb-3">
                  <div class="d-flex justify-content-between">
                    <h5>Listening 2</h5>
                    <p>{{examResult.scores.listening.second.score}}/{{examResult.scores.listening.second.max}}</p>
                  </div>
                  <app-progress-bar-simple [score]="calculPercent(examResult.scores.listening.second.score, examResult.scores.listening.second.max)"></app-progress-bar-simple>
                </div>
                <hr class="text-muted w-100 my-3">
                <div class="d-flex flex-column mb-3">
                  <div class="d-flex justify-content-between">
                    <h5>Listening 3</h5>
                    <p>{{examResult.scores.listening.third.score}}/{{examResult.scores.listening.third.max}}</p>
                  </div>
                  <app-progress-bar-simple [score]="calculPercent(examResult.scores.listening.third.score, examResult.scores.listening.third.max)"></app-progress-bar-simple>
                </div>
                <hr class="text-muted w-100 my-3">
                <div class="d-flex flex-column mb-3">
                  <div class="d-flex justify-content-between">
                    <h5>Listening 4</h5>
                    <p>{{examResult.scores.listening.fourth.score}}/{{examResult.scores.listening.fourth.max}}</p>
                  </div>
                  <app-progress-bar-simple [score]="calculPercent(examResult.scores.listening.fourth.score, examResult.scores.listening.fourth.max)"></app-progress-bar-simple>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="shadow rounded p-3 p-md-4 h-100">
            <h5>Reading</h5>
            <div class="d-flex flex-column flex-lg-row justify-content-between">
              <div class="text-center">
                <div class="mx-auto" style="max-height: 100px">
                  <app-progress-circle [responsive]="false" [radius]="50" [title]="displayPercent(calculPercent(examResult.scoreReading, 495))" [percent]="calculPercent(examResult.scoreReading, 495)"></app-progress-circle>
                </div>
              </div>
              <div class="d-flex flex-column w-100 mt-4 mt-lg-0">
                <div class="d-flex flex-column mb-3">
                  <div class="d-flex justify-content-between">
                    <h5>Reading 1</h5>
                    <p>{{examResult.scores.reading.first.score}}/{{examResult.scores.reading.first.max}}</p>
                  </div>
                  <app-progress-bar-simple [score]="calculPercent(examResult.scores.reading.first.score, examResult.scores.reading.first.max)"></app-progress-bar-simple>
                </div>
                <hr class="text-muted w-100 my-3">
                <div class="d-flex flex-column">
                  <div class="d-flex justify-content-between">
                    <h5>Reading 2</h5>
                    <p>{{examResult.scores.reading.second.score}}/{{examResult.scores.reading.second.max}}</p>
                  </div>
                  <app-progress-bar-simple [score]="calculPercent(examResult.scores.reading.second.score, examResult.scores.reading.second.max)"></app-progress-bar-simple>
                </div>
                <hr class="text-muted w-100 my-3">
                <div class="d-flex flex-column">
                  <div class="d-flex justify-content-between">
                    <h5>Reading 3</h5>
                    <p>{{examResult.scores.reading.third.score}}/{{examResult.scores.reading.third.max}}</p>
                  </div>
                  <app-progress-bar-simple [score]="calculPercent(examResult.scores.reading.third.score, examResult.scores.reading.third.max)"></app-progress-bar-simple>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="p-5 mx-5 mt-3" *ngIf="examResult">
      <div class="row">
        <div class="col-12 col-lg-4 mb-4">
          <div class="shadow rounded p-3 p-md-4 bg-white">
            <h3 class="mb-2" translate>Correction</h3>
            <select class="form-control rounded" (change)="onChangeType($event.target.value)">
              <option value="first_listening">Listening 1</option>
              <option value="second_listening">Listening 2</option>
              <option value="third_listening">Listening 3</option>
              <option value="fourth_listening">Listening 4</option>
              <option value="first_reading">Reading 1</option>
              <option value="second_reading">Reading 2</option>
              <option value="third_reading">Reading 3</option>
            </select>
            <div class="d-flex justify-content-center align-items-center flex-wrap mt-2">
              <ng-container *ngFor="let answers of getAnswers(); index as i; trackBy: trackByIndex">
                <div class="question-pin shadow rounded-circle d-flex justify-content-center align-items-center bolder m-2 text-white"
                     [class.bg-success]="answers.success"
                     [class.bg-danger]="!answers.success">
                  {{ i+1 }}
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-8">
          <div class="text-medium d-none d-md-block">
            <div class="row no-gutters">
              <div class="col-4 h-100 p-3"></div>
              <div class="col-3 h-100 p-3">
                <div class="d-flex align-items-center justify-content-start text-white" translate>
                  Votre réponse
                </div>
              </div>
              <div class="col-3 h-100 p-3">
                <div class="d-flex align-items-center justify-content-start text-white" translate>
                  Correction
                </div>
              </div>
              <div class="col-2 h-100 p-3"></div>
            </div>
          </div>
          <div
            class="row no-gutters rounded shadow mb-3 bg-white"
            *ngFor="let answer of getAnswers(); trackBy: trackByIndex"
            [class.error]="!answer.success"
            [class.success]="answer.success">
            <div class="col-10 col-md-12">
              <div
                class="py-3 py-md-0 row no-gutters">
                <div class="col-12 col-md-4 d-flex align-items-center justify-content-start px-3 p-md-3 mb-2 mb-md-0 nunito-bold">
                  <span *ngIf="!answer.questionImage" [innerHTML]="answer.question"></span>
                  <img [src]="answer.question | gameImage" class="img-fluid my-auto rounded-15" *ngIf="answer.questionImage"/>
                </div>
                <div class="col-12 col-md-3 d-flex align-items-center justify-content-start px-3 p-md-3 mb-2 mb-md-0">
                  <div>
                    <div translate class="text-medium d-block d-md-none text-sm mb-1 mt-2">Votre réponse</div>
                    <span *ngIf="!answer.answer">--</span> <span *ngIf="answer.answer">{{answer.answer}}</span>
                  </div>
                </div>
                <div class="col-12 col-md-3 d-flex align-items-center justify-content-start px-3 p-md-3">
                  <div *ngIf="!answer.success">
                    <div translate class="text-medium d-block d-md-none text-sm mt-2 mb-1">Correction</div>
                    <span [innerHTML]="answer.correction"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button class="btn btn-block btn-primary bolder px-3 py-2" (click)="navigateToLevels()" translate>Retour</button>
        </div>
      </div>
    </div>
  </div>
</div>
